var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('MyHeader')],1)],1),_c('el-row',[_c('el-col',{attrs:{"span":3}},[_c('MyAside')],1),_c('el-col',{attrs:{"span":21}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }